import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from '../../services/data.service';
import { TradeboardService } from '../../services/api/tradeboard.service';
import { ThreadService } from '../../services/api/thread.service';
import { CONSTANTS } from '../../constants';

@Component({
  selector: 'app-tradeboard-list',
  templateUrl: './tradeboard-list.component.html',
  styleUrls: ['./tradeboard-list.component.scss']
})
export class TradeboardListComponent implements OnInit {

  tradeboards: any = [];
  confirmation_params: any = { tag: '' };

  constructor(private router: Router, private dataService: DataService,
    private tradeboardService: TradeboardService) { }

  ngOnInit(): void {
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.TRADEBOARD});
    this.loadTradeboards();
  }

  loadTradeboards() {
    this.tradeboardService.getAllTradeboards().subscribe((response: any) => {
      this.tradeboards = response.tradeboards;
    });
  }

  openTradeboard(tradeboard: any) {
    this.dataService.clearTmpTradeboard();
    this.router.navigate(['/tah', 'tradeboard'], { state: { tradeboard: tradeboard }});
  }

  addTradeboard() {
    this.dataService.clearTmpTradeboard();
    this.router.navigate(['/tah', 'tradeboard'], { state: { add: true } });
  }

  deleteTradeboardConfirmation(tradeboard: any) {
    this.confirmation_params = { tag: tradeboard.name, obj: tradeboard };
  }

  deleteTradeboard() {
    let ip = { name: this.confirmation_params.obj.name };
    this.tradeboardService.deleteTradeboard(ip).subscribe((response: any) => {
      this.confirmation_params = { tag: '' };
      this.loadTradeboards();
    });
  }
}
